import React from 'react';
import { ArrowLeft, ClipboardCheck } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

export default function GuideChecklistIndexPage() {
    const navigate = useNavigate();

    return (
        <div className="px-4 py-5" data-testid="guide-checklist-index">
            <button onClick={() => navigate('/guide')} className="flex items-center gap-1 text-sm text-slate-500 mb-4 active:text-slate-700">
                <ArrowLeft className="w-4 h-4" /> Accueil
            </button>

            <h1 className="text-xl font-bold text-slate-900 mb-4">Fiches check-list</h1>

            <div className="space-y-3">
                <Link
                    to="/guide/checklist/arrivee"
                    className="block bg-white rounded-xl border border-slate-200 shadow-sm p-4 active:bg-slate-50"
                >
                    <h2 className="font-semibold text-blue-700 text-sm">Suivi de debut de service</h2>
                    <p className="text-xs text-slate-500 mt-1">Guide etape par etape pour bien demarrer</p>
                </Link>
                <Link
                    to="/guide/checklist/depart"
                    className="block bg-white rounded-xl border border-slate-200 shadow-sm p-4 active:bg-slate-50"
                >
                    <h2 className="font-semibold text-indigo-700 text-sm">Fiche de depart</h2>
                    <p className="text-xs text-slate-500 mt-1">Check-list de fermeture du stand</p>
                </Link>

                <Link
                    to="/guide/checklist/resultats"
                    className="flex items-center gap-3 bg-white rounded-xl border border-slate-200 shadow-sm p-4 active:bg-slate-50"
                    data-testid="checklist-results-link"
                >
                    <ClipboardCheck className="w-5 h-5 text-emerald-600 flex-shrink-0" />
                    <div>
                        <h2 className="font-semibold text-emerald-700 text-sm">Historique des resultats</h2>
                        <p className="text-xs text-slate-500 mt-0.5">Consultation des fiches validees</p>
                    </div>
                </Link>
            </div>
        </div>
    );
}
